"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useDataLinkTable(selector) {
  const { item: dataLinkTable, ...rest } = useElement(
    WorkspaceElementType.DataLinkTable,
    selector,
    (integrationApp) => selector ? integrationApp.dataLinkTable(selector) : void 0
  );
  return { dataLinkTable, ...rest };
}

export { useDataLinkTable };
